import React, { useEffect, useState } from 'react';

/** Plugins */
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { HighlightOff } from '@material-ui/icons';


/** Components */
import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

/** Services */
import { invalidatedAuth, getAuthRequests, getAuthRequestsByOrder, getAuthRequestsBySearch } from '../../services/authRequests';



/** Actions */
import { showAlert } from '../../store/ducks/alert';

const AuthRequests = ({ location, match }) => {
  const dispatch = useDispatch();
  const [pageData, setPageData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayPageData();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const invalidatedResquestAuth = async (id) => {
    try {
      if (id) {
         const response = await invalidatedAuth(id);
         dispatch(showAlert('success', 'Success, approved! 🔥'));
         window.location = '/authRequests';
      }
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something wrong happened. 😔'));
    }
  };

  const customActions = [
    {
      icon: <HighlightOff titleAccess='Invalidated Resquest Auth' />,
      action: item => {
        invalidatedResquestAuth(item.id);
      },
    },
  ];

  const displayPageData = async () => {
    try {
      setIsLoading(true);

      let pageData;
      if (isSearching) {
        const { data } = await getAuthRequestsBySearch(searchField.searchItem, searchField.search);
        pageData = data;
      } else if (isOrdering > 0) {
        const { data } = await getAuthRequestsByOrder(orderDirections.item, orderDirections.direction);
        pageData = data;
      } else if (!isOrdering && !isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getAuthRequests(page);
        pageData = data;
      }
      if (!pageData) return;

      setPageData(pageData.rows);
      setTotalItems(pageData.count);
      setTotalPages(pageData.pages);
      setPage(pageData.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['ip', 'email', 'invalidated', 'type',  'createdAt'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1> Authentication Requests ({totalItems})</h1>

        <SearchBox selectItems={headers} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} setIsOrdering={setIsOrdering} />
      </div>

      <DataTable
        head={headers}
        body={pageData}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
        customActions={customActions}
      />
    </>
  );
};

export default AuthRequests;
